export function range(from: number, to: number, step = 1): number[] {
    if (from === to && to === 0) {
        return [];
    }

    const [start, finish] = [from, to].sort((a, b) => a - b);
    const length = Math.floor((finish - start) / step) + 1;

    return Array.from(Array(length), (_, i) => start + (i * step));
}
